import openCaseSound from '../assets/music/open-case.mp3';
import sellSound from '../assets/music/sell.mp3';

const sounds = {
	open: new Audio(openCaseSound),
	sell: new Audio(sellSound)
};

// Предзагрузка звуков
Object.values(sounds).forEach(sound => {
	sound.load();
});

export const playSound = (soundName, shouldPlay = true) => {
	if (!shouldPlay) return;

	const sound = sounds[soundName];
	if (sound) {
		// Сброс звука на начало, если он уже проигрывается
		sound.currentTime = 0;
		sound.play().catch(error => {
			console.error('Error playing sound:', error);
		});
	}
};

export const stopAllSounds = () => {
	Object.values(sounds).forEach(sound => {
		sound.pause();
		sound.currentTime = 0;
	});
}; 